export class AltChunkInfo {
    constructor(relationId, position, subDocument) {
        this.relationId = relationId;
        this.position = position;
        this.subDocument = subDocument;
    }
}
